import { Autocomplete, TextField } from '@mui/material';
import { Control, Controller, UseFormGetValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { EnumListKey, useAllEnums } from '~/data/enums';
import { useFilterActiveEnumsByFormSelections } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/data/useFilterActiveEnumsByFormSelections';
import { Form } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/useScheduleChanges';

type Props = {
  control: Control<Form>;
  getValues: UseFormGetValues<Form>;
  index: number;
  disabled?: boolean;
};

export const EmploymentStatusComponent = (props: Props) => {
  const { control, index, getValues, disabled } = props;

  const { t } = useTranslation();
  const requiredText = t('fieldIsRequired');

  const { getEnums } = useAllEnums();

  const { filterActiveEnumsByFormSelections } =
    useFilterActiveEnumsByFormSelections({
      control,
      index,
      getValues,
    });

  const filteredOptions = filterActiveEnumsByFormSelections(
    getEnums(EnumListKey.EMPLOYMENT_STATUS),
  );

  return (
    <Controller
      control={control}
      name={`schedule.${index}.employmentDetails.fEmplDetailStatus`}
      rules={{ required: requiredText }}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Autocomplete
          options={filteredOptions}
          getOptionLabel={(o) => o?.name || ''}
          isOptionEqualToValue={(o, v) => o?.code === v?.code}
          onChange={(_, value) => onChange(value?.code || '')}
          value={filteredOptions.find((o) => o?.code === value) || null}
          disabled={disabled}
          size={'small'}
          data-testid="employment-status-autocomplete"
          renderInput={(params) => (
            <TextField
              {...params}
              label={t('laEmploymentStatus')}
              required={true}
              error={!!error}
              helperText={error?.message}
              data-testid="employment-status-input"
              slotProps={{ inputLabel: { shrink: true } }}
            />
          )}
          fullWidth={true}
        />
      )}
    />
  );
};
